__turbopack_context__.v({
  "active": "sjdsFG_active",
  "tabContainer": "sjdsFG_tabContainer",
});
